'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002414 from "./presto.-Presto$$anon$14.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$13() {
  this.bbT = null;
  this.bbL = null;
  this.bbM = false;
  this.bbU = null;
  this.bbV = false;
  this.bbY = null;
  this.bbR = null;
  this.bbS = false;
  this.bbN = null;
  this.bbO = false;
  this.bbP = null;
  this.bbQ = false;
  this.bbW = false;
  this.bbX = false;
  this.bbT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bbY = "MorbidUserDetails";
}
export { $c_Lpresto_Presto$$anon$13 as $c_Lpresto_Presto$$anon$13 };
$p = $c_Lpresto_Presto$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$13;
/** @constructor */
function $h_Lpresto_Presto$$anon$13() {
}
export { $h_Lpresto_Presto$$anon$13 as $h_Lpresto_Presto$$anon$13 };
$h_Lpresto_Presto$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bbT;
});
$p.M = (function() {
  if ((!this.bbM)) {
    this.bbL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbM = true;
  }
  return this.bbL;
});
$p.O = (function() {
  if ((!this.bbV)) {
    this.bbU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bbV = true;
  }
  return this.bbU;
});
$p.D = (function() {
  return this.bbY;
});
$p.t = (function() {
  if ((!this.bbS)) {
    this.bbR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbS = true;
  }
  return this.bbR;
});
$p.N = (function() {
  if ((!this.bbO)) {
    this.bbN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbO = true;
  }
  return this.bbN;
});
$p.Q = (function() {
  if ((!this.bbQ)) {
    this.bbP = new $j_presto$002e$002dPresto$0024$0024anon$002414.$c_Lpresto_Presto$$anon$14();
    this.bbQ = true;
  }
  return this.bbP;
});
$p.v = (function() {
  if ((!this.bbX)) {
    this.bbW = false;
    this.bbX = true;
  }
  return this.bbW;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee91) => ((p) => \u03b4scrutinee91.H3(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_Presto$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$13, "presto.Presto$$anon$13", ({
  Nh: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$13 as $d_Lpresto_Presto$$anon$13 };
//# sourceMappingURL=presto.-Presto$$anon$13.js.map
